module.exports = __webpack_public_path__ + "static/media/property_300sc.f08532bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/cenicilla_fresa/curativa/property_300sc.png
// module id = 1546
// module chunks = 3